import React from 'react';

const Separator = () => <span className="separator"> &gt; </span>;

const Breadcrumbs = () => (
  <div className="breadcrumbs">
    <a href="/">TAYLLORCOX</a>
    <Separator />
    <a href="/akademie">Akademie</a>
    <Separator />
    <a href="/gdpr">GDPR</a>
    <Separator />
    Audit
  </div>
);

export default Breadcrumbs;
